import React from "react";
import { loc } from "./Helpers/Localizations"
 
export default function Information() {
  return (
    <div>
      <h2>{loc('Information')}</h2>
    </div>
  )
}